module.exports = __webpack_public_path__ + "static/1.2767ca4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/news/1.jpg
// module id = 95
// module chunks = 72776394686286 82145767218184